import React, { useEffect, useState } from "react";
import { IconButton, Typography, Box } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import "./CountdownTimer.scss";
import { useTranslation } from "react-i18next";

interface CountdownTimerProps {
    targetDate: string; // Target date in ISO format
    onClose?: () => void; // Optional callback for the close button
}

interface TimeLeft {
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({ targetDate, onClose }) => {
    const { t } = useTranslation("countdown");
    const athensOffset = 2 * 60; // Athens is UTC+2 in minutes
    const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(calculateTimeLeft());
    const [isVisible, setIsVisible] = useState(true); // State to manage visibility

    // Function to calculate the time left
    function calculateTimeLeft(): TimeLeft | null {
        // Adjust for Athens timezone offset
        const now = new Date();
        const target = new Date(targetDate);
        const nowInAthens = new Date(now.getTime() + now.getTimezoneOffset() * 60000 + athensOffset * 60000);
        const targetInAthens = new Date(target.getTime() + target.getTimezoneOffset() * 60000 + athensOffset * 60000);

        const difference = targetInAthens.getTime() - nowInAthens.getTime();

        if (difference > 0) {
            return {
                days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, "0"),
                hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
                minutes: String(Math.floor((difference / (1000 * 60)) % 60)).padStart(2, "0"),
                seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
            };
        } else {
            return null; // Return null if the countdown is over
        }
    }

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer); // Cleanup on component unmount
    }, [targetDate]);

    // Function to handle the close button click
    // const handleClose = () => {
    //     setIsVisible(false); // Hide the timer when close button is clicked
    //     if (onClose) {
    //         onClose(); // If an onClose callback is provided, call it
    //     }
    // };

    if (!isVisible) {
        return null; // Do not render anything if the timer is hidden
    }

    if (!timeLeft) {
        return (
            <Typography>
            </Typography>
        );
    }

    return (
        <Box className="countdown-timer">
            <Typography className="countdown-timer__text">
                {t("Countdown description")}
                {/* {t("Countdown description")} {new Date(targetDate).toLocaleDateString("en-GB", { day: "numeric" })}{t("Countdown description p2")}{t(new Date(targetDate).toLocaleDateString("en-GB", { month: "long" }) as any)}. */}
            </Typography>
            <Box className="countdown-timer__timer">
                <Box className="countdown-timer__time-box">
                    <Typography className="countdown-timer__time-box-label">{t("DAYS")}</Typography>
                    <Typography className="countdown-timer__time-box-value">{timeLeft.days}</Typography>
                </Box>
                <Box className="countdown-timer__separator">:</Box>
                <Box className="countdown-timer__time-box">
                    <Typography className="countdown-timer__time-box-label">{t("HOURS")}</Typography>
                    <Typography className="countdown-timer__time-box-value">{timeLeft.hours}</Typography>
                </Box>
                <Box className="countdown-timer__separator">:</Box>
                <Box className="countdown-timer__time-box">
                    <Typography className="countdown-timer__time-box-label">{t("MINUTES")}</Typography>
                    <Typography className="countdown-timer__time-box-value">{timeLeft.minutes}</Typography>
                </Box>
                <Box className="countdown-timer__separator">:</Box>
                <Box className="countdown-timer__time-box">
                    <Typography className="countdown-timer__time-box-label">{t("SECONDS")}</Typography>
                    <Typography className="countdown-timer__time-box-value">{timeLeft.seconds}</Typography>
                </Box>
            </Box>
            {/* <IconButton
                aria-label="Close timer"
                className="countdown-timer__close-button"
                onClick={handleClose}
            >
                <CloseIcon />
            </IconButton> */}
        </Box>
    );
};
